import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, FormControlLabel, Grid, Theme, Typography } from "@mui/material";

import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateBSEFlag } from "../../../redux-store/actions/investorProfile";
import { LoadingButton } from "@mui/lab";
import { showError } from "../../../redux-store/actions/auth";

export default function Consent({ overviewData }: { overviewData: any }): JSX.Element {
    const dispatch = useDispatch();
    const { id, isEsignEnabled, isBSEEnabled } = overviewData || {};
    const [open, setOpen] = useState<boolean>(false);
    const [currentFlag, setCurrentFlag] = useState<string>('');
    const [message, setMessage] = useState<string>('');
    const [bseChecked, setBseChecked] = useState<boolean>(false);
    const [bseFlagLoading, setBseFlagLoading] = useState<boolean>(false);

    const handleCheckboxCheck = (type: string, checked: boolean) => {
        setOpen(true)
        setCurrentFlag(type);
        if (type === 'bse') {
            setMessage(`Do you want to ${checked ? 'enable' : 'disable'} BSE?`)
        }
        else {
            setMessage(`Do you want to ${checked ? 'enable' : 'disable'} E-Sign?`)
        }
    }

    const handleDialogSave = async () => {
        try {
            setBseFlagLoading(true);
            const res = await dispatch(updateBSEFlag({
                applicationId: id,
                isBSEEnabled: !bseChecked
            })) as any;

            if (!res) {
                setOpen(false)
                dispatch(showError(res?.message))
                return
            }

            setBseChecked(prevState => !prevState)
        } catch (e) {
            console.log('error', e);
        } finally {
            setBseFlagLoading(false);
        }
        setOpen(false)
    }

    return (
        <Box
            sx={(theme: Theme) => ({
                bgcolor: 'white',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                borderRadius: '10px',
                border: `1px solid ${theme.palette.grey[100]}`,
                padding: '25px',
                mb: '40px'

            })}
        >
            <Grid container >
                <Grid item xs={12} >
                    <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '25px' })}>
                        Consent
                    </Typography>
                </Grid>

                <Grid item xs={12} >
                    <FormControlLabel
                        sx={{ "&.MuiFormControlLabel-root": { cursor: (isBSEEnabled || bseChecked) ? 'not-allowed' : 'pointer' } }}
                        disabled={isBSEEnabled || bseChecked}
                        checked={(isBSEEnabled || bseChecked)}
                        control={<Checkbox />}
                        onChange={(e) => handleCheckboxCheck('bse', (e.target as HTMLInputElement).checked)}
                        label={
                            <Typography
                                variant="body_500"
                                color={(isBSEEnabled || bseChecked) ? 'text.secondary' : 'text.primary'}
                            >
                                Send to BSE
                            </Typography>
                        }
                    />
                </Grid>
                <Grid item xs={12} >
                    <FormControlLabel
                        sx={{ "&.MuiFormControlLabel-root": { cursor: "not-allowed" } }}
                        control={<Checkbox />}
                        disabled
                        checked={isEsignEnabled ?? false}
                        label={
                            <Typography
                                variant="body_500"
                                color='text.secondary'
                            >
                                Sent To E-Sign
                            </Typography>
                        }
                    />
                </Grid>
            </Grid>
            <Dialog
                onClose={setOpen}
                open={open}
                maxWidth='sm'
                fullWidth
                sx={{
                    '& .MuiPaper-root': {
                        borderRadius: '15px',
                        backgroundColor: "background.paper",
                        rowGap: "25px",
                    },
                }}
            >
                <DialogContent sx={{ paddingTop: "25px" }}>
                    <Box sx={{ display: "flex", columnGap: "8px" }}>
                        <Typography variant='h2' color="text.primary" mb="10px">{message}</Typography>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ padding: "25px", columnGap: "10px" }}>
                    <Button
                        variant="outlined"
                        onClick={() => setOpen(false)}
                        sx={(theme: Theme) => ({
                            color: theme.palette.text.secondary,
                            flex: 1,
                            border: `0.5px solid ${theme.palette.text.secondary}`,
                            padding: "10px",
                            "&:hover, &.Mui-focusVisible": {
                                borderColor: theme.palette.text.secondary,
                                backgroundColor: theme.palette.background.default
                            }
                        })}
                    >
                        {'No'}
                    </Button>
                    <LoadingButton
                        loadingPosition="start"
                        loading={bseFlagLoading}
                        variant="contained"
                        sx={(theme: Theme) => ({
                            flex: 1,
                            color: theme.palette.textDark.primary,
                            padding: "10px"
                        })}
                        onClick={handleDialogSave}
                    >
                        {'Yes'}
                    </LoadingButton>
                </DialogActions>
            </Dialog>

        </Box>
    )
}
